import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import usePermissions from "../../utils/permissions";
import { listIncludesId } from "../../utils/ids";

import { saveAs } from "file-saver";
import moment from "moment";
import {
  useMediaQuery,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Container,
  TextField,
  CircularProgress,
  FormControl,
  makeStyles,
  useTheme,
  createTheme,
  ThemeProvider,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import AddIcon from "@material-ui/icons/Add";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllClients } from "../../actions/clientActions";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { useLocation } from "react-router-dom";

import ProgressButton from "react-progress-button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  deleteStockAdjustment,
  getStockAdjustmentsByUser,
  getStockAdjustments,
} from "../../actions/stockAdjustmentActions";
import { getUsers } from "../../actions/auth";
import NoData from "../../components/svgIcons/NoData";
import Spinner from "../../components/Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typography: {
    fontSize: "18px",
    fontWeight: 500,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  button: {
    height: 100,
    width: 100,
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 14,
  cursor: "pointer",
  borderBottom: "none",
  padding: "8px",
  textAlign: "center",
};
const headerStyle = { borderBottom: "none", textAlign: "center" };
const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});

const StockAdjustments = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [downloadStatus, setDownloadStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));
  const stockAdjustments = useSelector(
    (state) => state.stockAdjustments.stockAdjustments
  );
  // //(stockAdjustments);
  const [rows, setRows] = useState([]);
  const { users } = useSelector((state) => state.auth);
  const clients = useSelector((state) => state.clients.clients);
  // //(users);
  // //(rows);
  const [loading, setLoading] = useState(false);
  const isLoading = useSelector((state) => state.stockAdjustments.isLoading);
  const [searchQuery, setSearchQuery] = useState("");
  const [salesperson, setSalesperson] = useState(null);
  const [party, setParty] = useState(null);
  const [adjustType, setAdjustType] = useState("");
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("");
  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    canCreatePage,
    isAdmin,
  } = usePermissions();

  // const rows = []

  // useEffect(() => {
  //     dispatch(getStockAdjustments());
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getStockAdjustments());

    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    if (user?.result?.userType === "user") {
      const rows = stockAdjustments.filter((inv) =>
        listIncludesId(inv.creator, user?.result?.id)
      );
      setRows(rows);
    } else {
      setRows(stockAdjustments);
    }

    // eslint-disable-next-line
  }, [stockAdjustments]);

  useEffect(() => {
    dispatch(getUsers());
  }, [location]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result.id || user?.result?.googleId })
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);
  const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // useEffect(() => {
  //   if (user?.result?.userType === "user") {
  //     const rows = stockAdjustments.filter(
  //       (inv) => inv.creator[0] === user?.result?.id
  //     );
  //     setRows( rows.filter(filterByDateRange));
  //   } else {
  //     setRows(stockAdjustments.filter(filterByDateRange));
  //   }
  // }, );
  const findUserNameById = (userId) => {
    // //("parameter" + userId);
    const user = users.find((user) => user.id == userId);
    // //(user);
    return user ? user.name : "";
  };

  const filterByDateRange = (stockAdjustment) => {
    if (!startDate || !endDate) return true;
    const stockAdjustmentDate = moment(stockAdjustment.createdAt);
    return stockAdjustmentDate.isBetween(startDate, endDate, "day", "[]");
  };
  // const filteredRows = rows;
  const filteredRows = rows.filter((row) => {
    const isSalespersonFilter = selectedFilter === "salesperson";
    const isAdjustTypeFilter = selectedFilter === "adjustType";
    const searchQueryLowerCase =
      searchQuery && typeof searchQuery === "string"
        ? searchQuery.toLowerCase()
        : "";

    if (isSalespersonFilter) {
      const creatorName = findUserNameById(row.creator).toLowerCase();
      return (
        filterByDateRange(row) && creatorName.includes(searchQueryLowerCase)
      );
    } else {
      const adjustType = row.adjustType.toLowerCase();
      console.log("Adjust type", adjustType);
      return (
        filterByDateRange(row) && adjustType.includes(searchQueryLowerCase)
      );
    }
    // else  {
    //   const clientName = row.client.name.toLowerCase();

    //   return (
    //     filterByDateRange(row) && clientName.includes(searchQueryLowerCase)
    //   );
    // }
  });
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value); // Update the selected filter when the user changes the option
  };
  const editStockAdjustment = (id) => {
    history.push(`/edit/stockAdjustment/${id}`);
  };
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this client?"
    );
    if (confirmDelete) {
      dispatch(deleteStockAdjustment(id, openSnackbar));
    }
  };

  const openStockAdjustment = (id) => {
    history.push(`/stockAdjustment/${id}`);
  };
  const createAndDownloadPdf = () => {
    //(rows);
    //(filteredRows);
    setLoading(true);
    if (filteredRows.length) {
      setDownloadStatus("loading");
      axios
        .post(`${process.env.REACT_APP_API}/create-adjustment-report`, {
          filteredRows,
          users,
        })
        .then(() =>
          axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
            responseType: "blob",
          })
        )
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          // const downloadUrl = window.URL.createObjectURL(pdfBlob);
          // setDownloadStatus("success");
          // window.open(downloadUrl, "_blank");
          const currentDate = new Date();

          saveAs(pdfBlob, `AdjustmentReport${currentDate}.pdf`);
          const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Adjustment-Reports/Report.pdf`;
          window.open(downloadUrl, "_blank");
          setLoading(false);
          setDownloadStatus("success");
        });
    } else {
      openSnackbar("No record to Export");
    }
  };
  const handleClientNameClick = (id) => {
    history.push(`/stats/${id}`);
  };
  if (!user) {
    history.push("/login");
  }

  const handleStartDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setEndDate(date);
  };
  const totalAmount = filteredRows.reduce((total, row) => {
    // Ensure that each row has an 'amount' property
    if (typeof row.total === "number") {
      return total + row.total;
    } else {
      return total;
    }
  }, 0);
  const salespersonsProps = {
    options: users,
    getOptionLabel: (option) => option.name,
  };
  // }
  // function checkStatus(status) {
  //   return status === "Partial"
  //     ? {
  //         border: "solid 0px #1976d2",
  //         backgroundColor: "#baddff",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Paid"
  //     ? {
  //         border: "solid 0px green",
  //         backgroundColor: "#a5ffcd",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Unpaid"
  //     ? {
  //         border: "solid 0px red",
  //         backgroundColor: "#ffaa91",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : "red";
  // }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <IconButton
          color="primary"
          aria-label="add to shopping cart"
          className={classes.button}
          onClick={() => (window.location.href = "/stockAdjustment")}
        >
          <AddIcon />
        </IconButton>
        {/* <Button
                variant="contained"
                color="primary"
               
                startIcon={<AddIcon />}
                
                style={{
                  margin: "16px 0 8px 0",
                  height: "50px",
                }}
              >
                Add
              </Button> */}

        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No Adjustments yet. Click the plus icon to create Order
        </p>
      </div>
    );
  }
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  return (
    <div
      style={{
        minHeight: isMobile ? "740px" : "470px",
      }}
    >
      <ThemeProvider theme={colorTheme}>
        <Container
          style={{
            width: isMobile ? "100%" : "85%",
            paddingTop: "2px",
            paddingBottom: "2px",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  required
                  format="yyyy/MM/dd"
                  style={{ maxWidth: isMobile ? "50%" : "100%" }}
                />

                <KeyboardDatePicker
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  required
                  format="yyyy/MM/dd"
                  style={{ maxWidth: "50%" }}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
                <FormControl style={{ width: "100px" }}>
                  <InputLabel>Filter:</InputLabel>
                  <Select
                    value={selectedFilter}
                    onChange={(event) => handleFilterChange(event)} // Provide the event object
                  >
                    <MenuItem value="salesperson">Filter by Store</MenuItem>

                    <MenuItem value="adjustType">
                      Filter by Adjust Type
                    </MenuItem>
                  </Select>
                  {selectedFilter && (
                    <IconButton
                      size="small"
                      style={{
                        marginLeft: "8px",
                        backgroundColor: "transparent",

                        color: "#ef7f1a",
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        setSelectedFilter("");
                        setSearchQuery("");
                        setSalesperson("");
                        setAdjustType("");
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </FormControl>
              {selectedFilter && (
                <div>
                  {/* Display filtering results or perform filtering logic based on selectedFilter */}
                  {selectedFilter === "salesperson" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {salesperson && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "5px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {salesperson.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setSalesperson(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            salesperson
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...salespersonsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!stockAdjustment && true}
                                label="Select Store"
                                margin="normal"
                                variant="outlined"

                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={users?.name}
                            onChange={(event, value) => {
                              setSalesperson(value);
                              setSearchQuery(value ? value.name : "");

                              console.log("value: ", value);
                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "adjustType" ? (
                    <div style={{ marginTop: "6.5px" }}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Adjust Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={adjustType}
                          required={true}
                          onChange={(e, value) => {
                            // console.log("StockAdjustment.js me  signature console.log",signatureDataUrl)
                            setAdjustType(e.target.value);
                            setSearchQuery(e.target.value);
                          }}
                          label="Payment Method"
                        >
                          <MenuItem value="Select">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value="Add">Add</MenuItem>
                          <MenuItem value="Deduct">Deduct</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}
                </div>
              )}
              {user?.result?.userType !== "admin" && (
                <ThemeProvider theme={colorTheme}>
                  <Container>
                    {party && (
                      <div
                        style={{
                          display: "flex",
                          marginTop: "20px",
                          gap: "10px",
                          height: "50px",
                        }}
                      >
                        <Typography variant="subtitle1" gutterBottom>
                          {party.name}
                        </Typography>

                        <Button
                          color="primary"
                          size="small"
                          style={{
                            textTransform: "none",
                            backgroundColor: "#ef7f1a",
                            color: "white",
                          }}
                          onClick={() => {
                            setParty(null);
                            setSearchQuery("");
                          }}
                        >
                          Change
                        </Button>
                      </div>
                    )}
                    <div
                      style={
                        party
                          ? { display: "none" }
                          : { display: "block", width: "200px" }
                      }
                    >
                      {/* <Autocomplete
                        {...clientsProps}
                        // PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // required={!stockAdjustment && true}
                            label="Select Party"
                            margin="normal"
                            variant="outlined"
                            // error={touched && !!errors.client}
                            // helperText={touched && errors.client}
                          />
                        )}
                        value={clients?.name}
                        onChange={(event, value) => {
                          setParty(value);
                          setSearchQuery(value ? value.name : "");

                          // handleClientChange();
                        }}
                        // onChange={(event, value) => setClient(value) }
                      /> */}
                    </div>
                  </Container>
                </ThemeProvider>
              )}

              {loading ? (
                <CircularProgress
                  style={{ marginTop: "20px", marginLeft: "10px" }}
                />
              ) : (
                user?.result?.userType === "admin" && (
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadPdf}
                    style={{
                      margin: "16px 0 8px 0",
                      height: "50px",
                    }}
                  >
                    PDF
                  </Button>
                )
              )}
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                startIcon={<AddIcon />}
                onClick={() => (window.location.href = "/stockAdjustment")}
                style={{
                  margin: "16px 0 8px 0",
                  height: "50px",
                  cursor:
                    permissionsLoading ||
                    (!isAdmin() && !canCreatePage("stockAdjustment"))
                      ? "not-allowed"
                      : "pointer",
                }}
                disabled={
                  permissionsLoading ||
                  (!isAdmin() && !canCreatePage("stockAdjustment"))
                }
              >
                Add
              </Button>
            </div>
            {/* {((startDate && endDate) ||
              salesperson ||
              party ||
              adjustType) && (
              <div
                className={classes.textContainer}
                style={{ margin: isMobile ? "0" : "10px 0 0 2rem" }}
              >
                <Typography variant="h6" className={classes.typography}>
                  Orders Count: {filteredRows.length}
                </Typography>

                <Typography variant="h6" className={classes.typography}>
                  Total Orders MRP: ₹{toCommas(totalAmount.toFixed(2))}
                </Typography>
              </div>
            )} */}
          </div>

          <TableContainer component={Paper} elevation={0}>
            <Table
              className={classes.table}
              aria-label="custom pagination table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={headerStyle}>ID</TableCell>

                  <TableCell style={headerStyle}>Date</TableCell>
                  <TableCell style={headerStyle}>
                    Stock Adjustment Type
                  </TableCell>
                  {/* <TableCell style={headerStyle}>Stock Adjust</TableCell>
                  <TableCell style={headerStyle}>Due Date</TableCell> */}

                  {/* <TableCell style={headerStyle}>Status</TableCell> */}
                    <TableCell style={headerStyle}>Store</TableCell>
                  {/* <TableCell style={headerStyle}>View</TableCell> */}

                  <TableCell style={headerStyle}>Edit</TableCell>

                  <TableCell style={headerStyle}>Delete</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? filteredRows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : filteredRows
                ).map((row) => (
                  <TableRow key={row.id} style={{ cursor: "pointer" }}>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openStockAdjustment(row.id)}
                    >
                      {" "}
                      {row.stockAdjustmentNumber}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openStockAdjustment(row.id)}
                    >
                      {" "}
                      {moment(row.createdAt).format("MMM Do YYYY")}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openStockAdjustment(row.id)}
                    >
                      {" "}
                      {row.adjustType}{" "}
                    </TableCell>
                    
                    {/* <TableCell
                      style={tableStyle}
                      onClick={() => openStockAdjustment(row.id)}
                    >
                      {row.currency}{" "}
                      {row.total ? toCommas(row.total) : row.total}{" "}
                    </TableCell> */}
                    {/* <TableCell style={tableStyle} onClick={() => openStockAdjustment(row.id)}>
                    {" "}
                    {moment(row.dueDate).fromNow()}{" "}
                  </TableCell> */}
                    {/* <TableCell
                    style={tableStyle}
                  >
                    {" "}
                    <button style={checkStatus(row.status)}>
                      {row.status}
                    </button>
                  </TableCell> */}
                      <TableCell
                        style={tableStyle}
                        onClick={() => openStockAdjustment(row.id)}
                      >
                        {" "}
                        {findUserNameById(row.creator)} {/* {row.creator} */}
                      </TableCell>
                    {/* <TableCell style={tableStyle}>
                    {" "}
                    <IconButton onClick={() => openStockAdjustment(row.id)}>
                      <RemoveRedEyeOutlinedIcon
                        style={{ width: "20px", height: "20px" }}
                      />
                    </IconButton>
                  </TableCell> */}

                    <TableCell style={{ ...tableStyle, width: "10px" }}>
                      <IconButton
                        onClick={() => editStockAdjustment(row.id)}
                        disabled={
                          permissionsLoading ||
                          (!isAdmin() && !canUpdatePage("stockAdjustment"))
                        }
                        style={{
                          cursor:
                            permissionsLoading ||
                            (!isAdmin() && !canUpdatePage("stockAdjustment"))
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <BorderColorIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>

                    <TableCell style={{ ...tableStyle, width: "10px" }}>
                      <IconButton
                        onClick={() => handleDelete(row.id)}
                        disabled={
                          permissionsLoading ||
                          (!isAdmin() && !canDeletePage("stockAdjustment"))
                        }
                        style={{
                          cursor:
                            permissionsLoading ||
                            (!isAdmin() && !canDeletePage("stockAdjustment"))
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <DeleteOutlineRoundedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      { label: "All", value: -1 },
                    ]}
                    colSpan={6}
                    count={filteredRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "rows per page" },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default StockAdjustments;
